import './_jquery';
import Masonry from 'masonry-layout';

jQuery(function() {
  let masonry, width;

  if (window.location.pathname === '/') {
    if (window.innerWidth < 768) {
      $('.mosaic-grid').remove();
    } else {
      $('.mosaic-grid--mobile').remove();
      width = 383.333;
      if (window.innerWidth >= 768 && window.innerWidth < 1150) {
        width = (window.innerWidth - 50) / 3; // 50px is wrap padding
      }
      masonry = new Masonry('.mosaic-grid', {
        itemSelector: '.mosaic-item',
        columnWidth: width
      });
    }
  }
});
